import { useDroppable } from '@dnd-kit/core';
import { onImageDropzoneInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../../state/hook.entry.js';
import { useInputState } from '../../../hook.use-input-state.js';
import { EmptyDropzone } from './atom.empty.js';
import { DropzoneWithTile } from './atom.with-tile.js';
import { jsx } from 'react/jsx-runtime';

function PlaceItemsOnImageDropzone(props) {
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => onImageDropzoneInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.dropzone.id])
  });
  const state = useInputState(props.dropzone, inputEntry, {
    forceValidation: (node, entry) => !!entry?.tileKey
  });
  const tileWithinId = props.facitType === "should-have" && state !== "correct" ? props.tiles.find(it => props.dropzone.validation.acceptedTileKeys.includes(it.itemKey))?.id : inputEntry?.tileId;
  const tileWithin = tileWithinId ? props.tiles.find(it => it.id === tileWithinId) : undefined;
  const tileState = props.facitType === "user-entry" ? state : props.dropzone.validation.acceptedTileKeys.includes(inputEntry?.tileKey ?? "") ? "correct" : "should-have";
  const {
    setNodeRef,
    isOver,
    node
  } = useDroppable({
    id: props.dropzone.id,
    disabled: !props.draggable,
    data: {
      tileWithinId
    }
  });
  if (tileWithin) {
    return /*#__PURE__*/jsx(DropzoneWithTile, {
      dropzoneRef: node,
      setNodeRef: setNodeRef,
      dropzone: props.dropzone,
      draggable: props.draggable,
      isDraggingTileWithin: props.draggedItemId === tileWithin.id,
      isOver: isOver,
      scale: props.scale,
      settings: props.settings,
      tileProps: {
        context: "dropzone",
        state: tileState,
        taskEntryKey: props.taskEntryKey,
        tile: tileWithin
      }
    }, tileWithinId);
  }
  return /*#__PURE__*/jsx(EmptyDropzone, {
    setNodeRef: setNodeRef,
    dropzone: props.dropzone,
    scale: props.scale,
    isOver: isOver,
    settings: props.settings
  });
}

export { PlaceItemsOnImageDropzone };
//# sourceMappingURL=_input.dropzone.js.map
